import fetchServer from "../fetchServer";

export default async function uploadFile(data,onUploadProgress) {
  let result = {return: 0,msg: 'Something went wrong uploading file!'}

  await fetchServer({method: 'POST',url: '/main/v1/tempFile/upload',data,
    onUploadProgress
  })
  .then((res) => {
    if(res?.data && !res?.data?.error) {
      result = {return: 1,msg: 'Successfull',data: res?.data?.data || []}
    } else result['msg'] = res?.data?.error || result['msg']
  })
  .catch((err) => {
    console.log('Network Error!')
  })

  return result;
}